// This component seems like a good candidate to factor out
// into react-components, doesn't it?

import React, { useEffect, useRef } from 'react';
// @ts-ignore
import CETEI from 'CETEIcean';
import './Ceteicean.css'

interface Props {
  content: string;
}

const Ceteicean: React.FC<Props> = (props) => {
  const teiDiv = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const getTEI = () => {
      const ct = new CETEI();

      const data = ct.makeHTML5(props.content)

      if (teiDiv.current) {
        teiDiv.current.innerHTML = data.outerHTML;
      }
    }

    getTEI();
  })

  return (
    <div className='tei-viewer' ref={teiDiv} />
  )
}

export default Ceteicean;
